var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{on:{"click":_vm.onClick}},[_vm._v(_vm._s(_vm.showRelative ? _vm.time.ago : _vm.time.text)+" "),(!_vm.noIcon)?_c('i',{staticClass:"las la-clock"}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }